/**
 * 消息中心
 **/

import React from 'react';
import {Col, message, Modal, Row, Table} from "antd";
import {findInformationPushes} from "../../services/informationPushes";
import TaskList from "../tasklist/TaskList";
import {connect} from "react-redux";
import {Link} from "react-router";
import {removeBlankValParamsStringParam} from "../../utils";
import taskType from "../../utils/taskType";
import {findBroadcast} from "../../services/dynamic";
import AccountSettings from '@/containers/usersfrom/AccountSettings';


class InformationList extends React.Component {

    constructor(props) {
        super(props);
        this.defaultTablePagination = {
            pageSizeOptions: ['1', '20', '50', '100'],
            defaultPageSize: 20,
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条`,
        }
        this.informationColumns = [{
            title: '标题',
            dataIndex: '',
            key:'id',
            width: 300,
            render: (text, record, index) => (
                <div>
                    {record.title}
                    <div style={{fontSize:12,color:'#9e9e9e',}}>{record.body}</div>
                </div>
            ),
        },{
            title: '时间',
            dataIndex: 'createTime',
            width: 160,
        },{
            title: '操作',
            dataIndex: 'title',
            width: 60,
            render: (text, record, index) => {
                const msgTypeList = [
                    'EVENT_ATTENDEE_IMT_NTF', 'EVENT_ATTENDEE_EXP_NTF', 'EVENT_ATTENDEE_QRCODE_EXT_NTF','EVENT_ATTENDEE_INFO_QRCODE_EXT_NTF',
                    'EVENT_ATTENDEE_CHECKIN_COUNT_EXT_NTF','EVENT_REPORT_TAIL_SINGIN_EXP_NTF', 'EVENT_ATTENDEE_COLLECT_COUNT_EXT_NTF',
                    'EVENT_INVITEE_IMT_NTF', 'EVENT_INVITEE_EXP_NTF', 'USER_CONTACT_IMP_NTF','EVENT_PDF_DIPLOMA_EXT_NTF',
                    'EVENT_PRICE_DRAW_EXP_NTF', 'EVENT_PRICE_ROLL_EXP_NTF', 'EVENT_ALLOT_EXP_NTF',
                    'SURVEY_EXP_NTF','VOTE_EXP_NTF','LUCKYMONEY_EXP_NTF','EVENT_ATTENDEE_BADGE_EXT_NTF',
                    'REWARD_DETAIL_EXP_NTF','MARKET_PURCHASE_EXP_NTF','GUESS_PLAYER_EXP_NTF','EVENT_ORDER_EXP_NTF','EVENT_ATTENDEE_PIC_NTF','EVENT_ATTENDEE_FILE_NTF',
                    'EVENT_ATTENDEE_FROM_CONTACT_IMT_NTF','EVENT_ATTENDEE_INVOICE_EXT_NTF','EVENT_LEVEL_SHARE_EXP_NTF','EVENT_CODE_SHARE_EXP_NTF',
                    'EVENT_WJW_MAKE_EXP_NTF','EVENT_CHECKIN_CREDIT_EXP_NTF','GUEST_GROUP_EXP_NTF','LEAP_EVENT_EXP_NTF','EVENT_CHECKIN_LOG_EXP_NTF'
                ];
                return <span>
                    {msgTypeList.includes(record.msgType) &&
                    <a href="#" onClick={() => {
                        const params = {
                            type: taskType[record.msgType].type
                        };
                        if (record.msgType != "USER_CONTACT_IMP_NTF") {
                            params.eventId = record.forward.split('/')[2];
                        }
                        if(record.msgType == 'SURVEY_EXP_NTF' || record.msgType == 'VOTE_EXP_NTF' || record.msgType == 'REWARD_DETAIL_EXP_NTF' ||
                            record.msgType == 'MARKET_PURCHASE_EXP_NTF' || record.msgType == 'GUESS_PLAYER_EXP_NTF' || 
                            record.msgType == 'EVENT_CHECKIN_CREDIT_EXP_NTF' || record.msgType =='GUEST_GROUP_EXP_NTF' || record.msgType == 'LEAP_EVENT_EXP_NTF'){
                            params.eventId = null;
                        }
                        this.setState(params, () => {
                            this.setState({taskVisible: true})
                        })
                    }}>详情</a>}

                    {record.msgType === 'BROADCAST_NTF' &&
                    <a href="#" onClick={() => this.fetchBroadcast(JSON.parse(record.extra).id)}>查看</a>}
                    {record.msgType === 'EVENT_ATTENDEE_CREATED_NTF' &&
                    <Link onClick={()=>this.props.hide()} to={`/admin/evtm/evt/${JSON.parse(record.extra).eventId}/attendee/approved`}>查看</Link>}
                    {record.msgType === 'EVENT_CHECKIN_CPT' &&
                    <Link onClick={()=>this.props.hide()} to={`/admin/evtm/evt/${JSON.parse(record.extra).eventId}/checkinlog`}>查看</Link>}
                    {record.msgType === 'EVENT_APPLY_CREATE_NTF' &&
                    <a href="#" onClick={() => this.handleCancelUserInfo(true)}>查看</a>}
                </span>
            },
        },];
        this.state = {
            eventId:null,
            type:null,
            broadcastVisible:false,
            broadcastItem:null,
            informationResponse: {
                isFetching: true,
                data: [],
                pagination: {
                    total: 0,
                    defaultPageSize: 20,
                    current: 1,
                },
            },
            informationSearchParams: {
                transDirection: ""
            },

        }
    }

    componentWillReceiveProps(nextProps) {


    }

    componentDidMount() {
        this.fetchCashAccountTrans()
    }
    fetchBroadcast = (id) =>{
        findBroadcast({bId:id}).then(res => {
            if (res.code == 200) {
                this.setState({
                    broadcastVisible:true,
                    broadcastItem:res.data,
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }


    fetchCashAccountTrans(pagination, sort) {
        const params = Object.assign(removeBlankValParamsStringParam(this.state.informationSearchParams),{page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})
        findInformationPushes(params).then(res => {
            if (res.code == 200) {
                const {data, ...page} = res
                this.setState({
                    informationResponse: {
                        taskVisible:false,
                        isFetching: false,
                        data: data,
                        pagination: {
                            total: page.total,
                            defaultPageSize: page.pageSize,
                            current: page.page,
                        },
                    },
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    informationTableChange = (pagination, filters, sorter) => {
        this.fetchCashAccountTrans(pagination, sorter);
    }
    informationSearchParamsChange(propName, val, invokingFetchFilterTableData = true) {
        const searchParams = {...this.state.informationSearchParams};
        searchParams[propName] = val;
        this.setState({
            informationSearchParams: searchParams,
        }, () => {
            if (invokingFetchFilterTableData) {
                this.fetchCashAccountTrans();
            }
        });
    }
    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    hideModal = () => {
        this.setState({
            taskVisible: false,
        });
    }
    handleCancelUserInfo = (e) => {
        this.setState({
            userInfoVisible: e,
        });
    }


    render() {
        const {broadcastItem} =this.state;
        const content = <Row>
            <Col span={24}>
                <Table
                    columns={this.informationColumns}
                    showHeader={false}
                    loading={this.state.informationResponse.isFetching}
                    dataSource={this.state.informationResponse.data}
                    pagination={Object.assign({}, this.defaultTablePagination, this.state.informationResponse.pagination)}
                    onChange={this.informationTableChange}
                    scroll={{x: 546, y: 'calc(100vh - 518px)'}}
                />
            </Col>
        </Row>
        return (
            <div>
                {content}
                <Modal
                    bodyStyle={{paddingTop: 10}}
                    width={1000}
                    title="任务列表"
                    visible={this.state.taskVisible}
                    onCancel={this.hideModal}
                    footer={null}
                >
                    <TaskList eventId={this.state.eventId} type={this.state.type}/>

                </Modal>

                <Modal
                    width={700}
                    title={broadcastItem ? broadcastItem.title : ''}
                    closable={false}
                    visible={this.state.broadcastVisible}
                    onCancel={()=>this.setState({broadcastVisible:false})}
                    footer={null}
                >
                    <div dangerouslySetInnerHTML={{ __html:broadcastItem ? broadcastItem.content : ''}}>

                    </div>
                </Modal>
                <Modal
                    width={1000}
                    title="个人中心"
                    visible={this.state.userInfoVisible}
                    onCancel={()=>this.handleCancelUserInfo(false)}
                    footer={null}
                >
                    {this.state.userInfoVisible ? <AccountSettings activeKey={'11'} visibleHide={()=>this.handleCancelUserInfo(false)}/> : ''}
                </Modal>
            </div>

        )
    }
}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({});


export default connect(mapStateToPorps, mapDispatchToProps)(InformationList);



// WEBPACK FOOTER //
// ./src/containers/information/InformationList.jsx